import type { Page } from '../../types';

const recruitmentCampaigns: Page[] = [
  {
    pageType: 'question',
    title: 'Recruitment Campaigns',
    name: 'phone-number-list',
    hidePageTitle: true,
    description: '',
    hideContinueButton: true,
    navigateToSummaryOnComplete: true,
    questions: [
      {
        questionType: 'textInputSmall',
        title:
          'Total number of fair and open recruitment campaigns that were completed in the quarter',
        name: 'total-number-fair-recruitment',
        // detailsHeading: 'More information',
        detailsContent:
          'Total number of fair and open recruitment campaigns that were completed in the quarter',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'recruitmentCampaignInput',
        title: 'Breakdown',
        name: 'recruitment-campaign-grade-column',
        detailsHeading: 'More information',
        detailsContent: `<p>If the grade does not align directly, you can use the equivalent.</p>
                           <p>The data provided in this section should include numbers from any arm's length bodies, if these numbers relate to the appointment of civil servants or the advertisement of civil service vacancies. </p>`,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title:
          'Have you run a campaign during this quarter which recruited more than 20 people in a single campaign?',
        name: 'recruit-more-20',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
        errorMessages: { required: 'Please answer -  Have you recruited more than 20!' },
      },
      {
        questionType: 'radio',
        title:
          'Have you run a campaign during this quarter which recruited staff into more than one operating location?',
        name: 'recruit-more-than-one-location',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
        errorMessages: {
          required:
            'Please answer -  Have you run a campaign during this quarter which recruited staff into more than one operating location?',
        },
      },
    ],
  },
];
export default recruitmentCampaigns;
